import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';

import { environment } from 'src/environments/environment';
import { getFirebaseIdToken } from '../methods/firebase-id-token';

export const FIREBASE_ID_TOKEN_RESOLVER = new InjectionToken<() => Promise<string | null>>(
  'Firebase ID token resolver',
  {
    providedIn: 'root',
    factory: () => getFirebaseIdToken,
  }
);

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(FIREBASE_ID_TOKEN_RESOLVER) private readonly getIdToken: () => Promise<string | null>
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.startsWith(environment.cloudrun.gskApi)) {
      return next.handle(request);
    }

    return from(this.getIdToken()).pipe(
      switchMap((idToken) => {
        if (!idToken) {
          return next.handle(request);
        }

        return next.handle(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${idToken}`,
            },
          })
        );
      })
    );
  }
}
